module.exports = __webpack_public_path__ + "img/new3-img3.7c2a3e9e.jpg";